export default __webpack_public_path__ + "static/media/LOGO-BRASIL-ADM.551e91fc.png";